import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../../components/Component";
import BillPicture from "../../../components/picture/Picture";
import { GET, POST, PUT } from "../../../helper/api";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { BILL_STATUS, getDefaultPnBill, randomString } from "../../../utils/Utils";
import PnBillForm from "./form/PnBillForm";

const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const PNBill = () => {
  const history = useHistory();
  const { search } = useLocation();
  const duplicateId = new URLSearchParams(search).get("duplicateId");
  const params = useParams();
  const id = duplicateId || params.id;
  const isEdit = params.id && !duplicateId;
  const methodForm = useForm({
    defaultValues: {
      ...getDefaultPnBill()
    },
    shouldFocusError: true,

  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = methodForm;
  const [loading, setLoading] = useState(false);

  const [smOption, setSmOption] = useState(false);

  const [deliveryFeeByDistanceInternal, setDeliveryFeeByDistanceInternal] = useState([]);
  const [deliveryFeeByDistanceExternal, setDeliveryFeeByDistanceExternal] = useState([]);
  const [locationDistance, setLocationDistance] = useState([]);

  const [driveRentalContractOptions, setDriveRentalContractOptions] = useState([]);

  const fromLocation = watch("fromLocation");
  const toLocation = watch("toLocation");
  const truckId = watch("truckId");
  const location = watch("location");

  const driveRentalContractId = watch("driveRentalContractId");
  const status = watch("status");


  useEffect(() => {
    GET("/drive-rental-contract", {
      status: 'INIT'
    }, true).then((resp) => {
      const { data: { rows } } = resp;
      if (rows) {
        setDriveRentalContractOptions((oldOptions) => {
          const newOptions = [...oldOptions];
          const oldOptionValues = oldOptions.map(c => c.value);
          rows.forEach((c) => {
            if (!oldOptionValues.includes(c.id)) {
              newOptions.push({
                label: `${c?.customer?.name} - HĐ số ${c.id} - Từ "${c?.info?.from}" đến "${c?.info?.to}"`,
                value: c.id,
                data: c,
              })
            }
          })

          return newOptions;
        });
      }
    });

    GET("/delivery-fee-by-distance", {}, true).then((resp) => {
      const { data } = resp;
      setDeliveryFeeByDistanceInternal(
        data.rows.filter((c) => c.location === "INTERNAL").sort((a, b) => a.distance - b.distance)
      );
      setDeliveryFeeByDistanceExternal(data.rows.filter((c) => c.location === "EXTERNAL"));
    });

    GET("/location-distance", {}, true).then((resp) => {
      const { data } = resp;
      setLocationDistance(data);
      const fromObj = {};
      const toObj = {};
      data.forEach((c) => {
        fromObj[c.fromLocation] = c.fromLocationName;
        toObj[c.toLocation] = c.toLocationName;
      });

    });
  }, []);

  useEffect(() => {
    if (id) {
      GET(`/pn-bill/${id}`, {}, true)
        .then((resp) => {
          const { data } = resp;
          data.createdAt = moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss");
          if (duplicateId) {
            data.id = `${duplicateId}-${randomString(10)}`
          }
          reset(data);
          const { driveRentalContract } = data

          if (driveRentalContract) {
            setDriveRentalContractOptions((oldOptions) => {
              const newOptions = [...oldOptions];
              const oldOptionValues = oldOptions.map(c => c.value);
              if (!oldOptionValues.includes(driveRentalContract.id)) {
                newOptions.push({
                  label: `${driveRentalContract?.customer?.name} - HĐ số ${driveRentalContract.id} - Từ "${driveRentalContract?.info?.from}" đến "${driveRentalContract?.info?.to}"`,
                  value: driveRentalContract.id,
                  data: driveRentalContract,
                })
              }
              return newOptions;
            });
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
          history.goBack();
        })

    }
  }, [id]);

  const onReCalculate = (e) => {
    e.preventDefault();
    const { fromLocation, toLocation, truckId, location, driverId, subDriverId } = getValues();

    if (location === "EXTERNAL") {
      const deliveryFeeByDistanceData = deliveryFeeByDistanceExternal.find((c) => c.location === location && c.truckIds.includes(truckId) && c.warehouseIds.includes(fromLocation));
      if (!deliveryFeeByDistanceData) {
        toast.error("Chưa cài phí vận chuyển theo khoảng cách");
        return
      }
      setValue("deliveryFeeExternal", deliveryFeeByDistanceData.deliveryFeeExternal);
      setValue("driverBonus", driverId ? deliveryFeeByDistanceData.driverBonus : 0);
      setValue("subDriverBonus", subDriverId ? deliveryFeeByDistanceData.subDriverBonus : 0);
      return
    } else {
      let deliveryFeeByDistanceData = null;
      if (driveRentalContractId) {
        const driveRentalContract = driveRentalContractOptions.find((c) => c.value === driveRentalContractId)?.data;
        if (driveRentalContract) {
          deliveryFeeByDistanceData = driveRentalContract.deliveryFeeByDistanceData.find(
            (c) => c.truckIds.includes(truckId)
          );
        }
      } else {
        const locationDistanceData = locationDistance.find((c) => c.fromLocation === fromLocation && c.toLocation === toLocation);
        if (!locationDistanceData) {
          toast.error("Chưa cài khoảng cách giữa 2 điểm");
          return
        }
        deliveryFeeByDistanceData = deliveryFeeByDistanceInternal.find(
          (c) => c.truckIds.includes(truckId) && c.distance >= locationDistanceData.distance
        );
        if (!deliveryFeeByDistanceData) {
          toast.error("Chưa cài phí vận chuyển theo khoảng cách");
          return
        }
      }


      setValue("deliveryFeeByWeight", deliveryFeeByDistanceData.deliveryFeeByDistance);
      setValue("driverBonus", driverId ? deliveryFeeByDistanceData.driverBonus : 0);
      setValue("subDriverBonus", subDriverId ? deliveryFeeByDistanceData.subDriverBonus : 0);
    }
  }


  const onHandleSubmit = () => {
    setLoading(true);
    const data = getValues();
    const {
      createdAt,
      fromLocation,
      toLocation,
      customerDirection,
      ingredientVATName,

      customerId,
      type,

      ingredientId,
      truckId,
      location,
      finalMerchandiseWeight,

      driveRentalContractId,
      deliveryFeeByWeight,
      deliveryFeeExternal,
      note,

      driverId,
      subDriverId,
      driverBonus,
      subDriverBonus,

      status,
      billPictures,
      seaportId,
    } = data

    const formData = {
      createdAt,
      fromLocation,
      toLocation,

      customerId,
      type,
      customerDirection,
      ingredientVATName,
      ingredientId,
      truckId,
      location: location || 'INTERNAL',
      seaportId: seaportId || null,
      finalMerchandiseWeight: finalMerchandiseWeight || 1,

      driveRentalContractId,
      deliveryFeeByWeight: deliveryFeeByWeight || 0,
      deliveryFeeExternal: deliveryFeeExternal || 0,
      note: note || null,

      driverId: driverId || null,
      subDriverId: subDriverId || null,
      driverBonus: driverBonus || 0,
      subDriverBonus: subDriverBonus || 0,

      status,
      billPictures: billPictures?.map((c) => c.src) || [],
    };
    const request = isEdit
      ? PUT(
        `/pn-bill/update/${id}`,
        formData,
        {},
        true
      )
      : POST(
        `/pn-bill/create/${data.id}`,
        formData,
        {},
        true
      );

    request
      .then((res) => {
        if (id) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };


  return (
    <React.Fragment>
      <Head title="Đơn hàng"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    <form>
                      <PnBillForm
                        id={id}
                        driveRentalContractOptions={driveRentalContractOptions}
                      />

                      <Row className="mt-4">
                        <Col size={12}>
                          <BillPicture disabledUpload={status === BILL_STATUS.APPROVED} />
                        </Col>
                      </Row>

                      <BlockHead className={`mt-3`}>
                        <BlockHeadContent>
                          <BlockTitle tag="h5" className={`text-primary`}>Chức năng</BlockTitle>
                        </BlockHeadContent>
                      </BlockHead>
                      <Row className="mt-3">
                        <Col size="12" md={3}>
                          <div className="form-group">
                            <label className="form-label" >
                              Trạng thái đơn<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="status"
                                rules={{
                                  required: "Vui lòng nhập thông tin",
                                }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={BILL_STATUS_OPTIONS}
                                    value={
                                      BILL_STATUS_OPTIONS.find((c) => c.value === value) ||
                                      null
                                    }
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="status"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-3 ">
                        <Col size="3" className="mt-3">
                          <Button color="secondary" type="button" onClick={onReCalculate} disabled={((!fromLocation || !toLocation) && !driveRentalContractId) || !truckId || !location}>
                            <span>Tính lại tiền tài</span>
                          </Button>
                          <Button color="primary" type="button" className={`ml-2`} onClick={handleSubmit(onHandleSubmit)}>
                            <span>Lưu đơn hàng</span>
                          </Button>

                        </Col>

                      </Row>
                    </form>
                    {/* <PNBillHistoryComponent formComponent={(props) => <PnBillForm {...props} driveRentalContractOptions={driveRentalContractOptions} />} /> */}
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNBill;
